import styled from 'styled-components';

export const SSOButtonsContainer = styled.div`
  gap          : 15px;
  width        : 100%;
  display      : flex;
  flex-direction: column;
`;